export default __webpack_public_path__ + "static/media/gardening2.a399abda.jpeg";